import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { BtwButton, Pin, cn } from '@marvelapp/ballpark-components';
import { CloseIcon } from '@marvelapp/ballpark-icons';
export const DeleteCornerButton = observer(function DeleteCornerButton(props) {
    const { className } = props, rest = __rest(props, ["className"]);
    return (_jsx(Pin.Tr, { className: "-mr-2.5 -mt-2.5", children: _jsx(BtwButton, Object.assign({ className: cn('h-5', 'w-5', 'scale-50', 'opacity-0', 'group-hover:scale-100', 'group-hover:opacity-100', className), size: "sm", standaloneIcon: _jsx(CloseIcon, {}), variant: "danger" }, rest)) }));
});
